// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-tooltip__popper{width:275px!important;height:73px!important;font-size:14px!important;border:1px solid rgba(226,222,222,.877)!important;box-shadow:3px 6px 19px -1px rgba(184,176,176,.56)}.el-tooltip__popper[x-placement^=right-start] .popper__arrow:after{border-color:none}.el-tooltip__popper[x-placement^=right-start] .popper__arrow{display:none}.bg-submit[disabled=disabled]{background-color:#eee!important}", ""]);
// Exports
module.exports = exports;
